import { useQuery } from "@tanstack/react-query"
import apiRoutes from "../apiRoutes"
import api from "../utils"
import { useAppDispatch } from "../app/hooks"
import { setAnnouncement } from "../features/userSlice"

export const useInitData = () => {
    const dispatch = useAppDispatch()
    const getInitData = async () => {
        const res = await api.get(apiRoutes.home)
        return res.data
    }

    const { data: homeData, ...rest } = useQuery<HomeData>({
        queryKey: ["home_items"],
        queryFn: getInitData,
        onSuccess: (data) => {
            dispatch(setAnnouncement(data?.info?.announcements))
        }
    })

    return {
        homeData,
        ...rest
    }
}